if (!customElements.get('shark-random-products')) {
  class SharkRandomProducts extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.loadProducts();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      } else {
        this.loadProducts();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }

    shuffledCards(root) {
      const pool = root.querySelector('template[data-random-product-pool]');
      const seen = new Set([String(this.dataset.productId)]);
      const cards = [...(pool?.content.querySelectorAll('li[data-product-id]') || [])]
        .filter((card) => {
          const id = card.dataset.productId;
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        });
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      return cards;
    }

    async loadProducts() {
      const fallback = this.shuffledCards(this);
      let cards = fallback;
      const pages = Math.max(1, Number(this.dataset.pageCount) || 1);
      const page = Math.floor(Math.random() * pages) + 1;
      if (page !== Number(this.dataset.currentPage)) {
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 4000);
        try {
          const url = new URL(this.dataset.url, window.location.origin);
          if (url.origin !== window.location.origin) throw new Error('Invalid product origin');
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set(this.dataset.pageParam || 'page', String(page));
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Product selection unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const root = html.querySelector('shark-random-products');
          if (root?.dataset.productId !== this.dataset.productId) throw new Error('Product context changed');
          const selected = this.shuffledCards(root);
          if (selected.length) {
            const ids = new Set(selected.map((card) => card.dataset.productId));
            cards = selected.concat(fallback.filter((card) => !ids.has(card.dataset.productId)));
          }
        } catch {
          cards = fallback;
        } finally {
          clearTimeout(timeout);
        }
      }
      if (!this.isConnected) return;
      const limit = Math.max(1, Math.min(10, Number(this.dataset.limit) || 4));
      const selected = cards.slice(0, limit);
      const layout = this.querySelector('template[data-random-product-layout]');
      if (!selected.length || !layout) {
        this.closest('[id^="shopify-section-"]')?.setAttribute('hidden', '');
        return;
      }
      const fragment = layout.content.cloneNode(true);
      const list = fragment.querySelector('.swiper-wrapper');
      if (!list) return;
      selected.forEach((card) => list.append(card.cloneNode(true)));
      this.replaceChildren(fragment);
      this.dataset.selectedIds = selected.map((card) => card.dataset.productId).join(',');
      this.dataset.loaded = 'true';
      this.classList.add('product-recommendations--loaded');
    }
  }
  customElements.define('shark-random-products', SharkRandomProducts);
}


